import {
  Box,
  Flex,
  Text,
  forwardRef,
  useDisclosure,
  useOutsideClick,
  Tooltip
} from '@chakra-ui/react'
import { createRef } from 'react'
import { useHistory } from 'react-router-dom'

import useAlertPurchase from '@hook/alerts/use-alert-purchase'

import type { ILink } from '@base/@types/components/Layout/Navigator'

import NavigatorDropdown from './Dropdown'

interface INavigatorTabProps extends ILink {
  active: boolean
  isLast: boolean
  isFirst: boolean
}

const NavigatorTab = forwardRef((props: INavigatorTabProps) => {
  const dropdownRef = createRef<HTMLDivElement>()
  const history = useHistory()

  const { group, icon, path, menu, active, isLast, isFirst, external } = props

  const { isOpen, onOpen, onClose } = useDisclosure()
  const { quantityProcess = [] } = useAlertPurchase()
  useOutsideClick({
    ref: dropdownRef,
    handler: onClose
  })

  const handleClick = () => {
    if (path) {
      if (external) {
        return window.open(path, '_blank')
      } else {
        return history.push(path)
      }
    }

    onOpen()
  }

  return (
    <>
      <Box
        ref={dropdownRef}
        d="flex"
        flexDir="row"
        paddingTop="18px"
        paddingBottom="9px"
        alignItems="initial"
        justifyContent="center"
        transition="all ease .3s"
        _focus={{ boxShadow: 'none' }}
        onClick={handleClick}
      >
        <Box position="relative" mr={2}>
          <Flex
            w="28px"
            h="28px"
            cursor="pointer"
            fontSize="18px"
            borderRadius="4px"
            alignItems="center"
            justifyContent="center"
            bgColor={active ? '#f9e900' : 'rgba(255, 255, 255, 0.1)'}
            color={active ? 'green.600' : 'gray.400'}
            transition="all ease .3s"
            _hover={{
              bgColor: active ? '#e3d400' : 'rgba(255, 255, 255, 0.2)'
            }}
          >
            {icon}
          </Flex>

          {group === 'Alertas' && (
            <Tooltip
              hasArrow
              placement="top"
              bg="white"
              color="gray.800"
              boxShadow="md"
              px={4}
              py={2}
              borderRadius="md"
              label={
                <Box>
                  {[
                    { status: 0, label: 'Iniciando' },
                    { status: 1, label: 'Processamento' },
                    { status: 2, label: 'Concluídos' },
                    { status: 4, label: 'Aguardando Aprovação' },
                    { status: 5, label: 'Recusado' },
                    { status: 3, label: 'Erro' }
                  ].map(({ status, label }) => {
                    const count =
                      quantityProcess.find(q => q.statusPedido === status)
                        ?.total || 0
                    return (
                      <Flex
                        key={status}
                        justify="space-between"
                        w="220px"
                        mb="2px"
                      >
                        <Text fontWeight="medium">{label}</Text>
                        <Text fontWeight="bold">{count}</Text>
                      </Flex>
                    )
                  })}
                </Box>
              }
            >
              <Box
                position="absolute"
                top="-8px"
                right="-10px"
                bg="red.500"
                color="white"
                fontSize="10px"
                minW="20px"
                h="20px"
                borderRadius="full"
                display="flex"
                alignItems="center"
                justifyContent="center"
                px={1}
                boxShadow="sm"
                zIndex={1}
                fontWeight="bold"
              >
                {quantityProcess.reduce((acc, cur) => acc + cur.total, 0)}
              </Box>
            </Tooltip>
          )}
        </Box>

        <Text
          cursor="pointer"
          fontSize="15px"
          transition="all ease .3s"
          color={active ? 'white' : 'gray.300'}
          _hover={{
            color: active ? 'white' : 'white'
          }}
        >
          {group}
        </Text>
      </Box>

      {!!menu && (
        <NavigatorDropdown
          id={`navlink-group-${group.split(' ').join('-').toLowerCase()}`}
          dropdownRef={dropdownRef}
          isOpen={isOpen}
          menu={menu}
          group={group}
          right={isLast}
          left={isFirst}
        />
      )}
    </>
  )
})

export default NavigatorTab
